import{useState as o,useEffect as t}from"react";var n=function(){var n=o(!1),e=n[0],r=n[1];return t((function(){var o;o=e?"hidden":"scroll",document.documentElement.style.overflowY=o}),[e]),{showModal:e,toggleModal:function(){r((function(o){return!o}))}}};export{n as default};
//# sourceMappingURL=use-modal.js.map
